/**
 * tdesign v1.1.1
 * (c) 2023 tdesign
 * @license MIT
 */

import { _ as _toConsumableArray } from '../../../_chunks/dep-56ceb7ce.mjs';
import { _ as _defineProperty } from '../../../_chunks/dep-b011b919.mjs';
import { defineComponent, computed, reactive, watch, createVNode, mergeProps } from 'vue';
import { t as throttle_1 } from '../../../_chunks/dep-617caa79.mjs';
import props from '../../props.mjs';
import '../../utils/index.mjs';
import { Input } from '../../../input/index.mjs';
import { InputNumber } from '../../../input-number/index.mjs';
import { FORMAT_INPUT_CONFIG } from './config.mjs';
import { Color } from '../../../_common/js/color-picker/color.mjs';
import '../../../_chunks/dep-2a2a0e63.mjs';
import '../../../_chunks/dep-ae1abe1d.mjs';
import '../../../_chunks/dep-eba62589.mjs';
import '../../../_chunks/dep-83588d06.mjs';
import '../../../_chunks/dep-16e2f1a5.mjs';
import '../../../_chunks/dep-8d19eb1a.mjs';
import '../../../_chunks/dep-7d9e11c8.mjs';
import '../../../_chunks/dep-63c5b255.mjs';
import '../../../_chunks/dep-06221fe2.mjs';
import '../../../_chunks/dep-a6022780.mjs';
import '../../../_common/js/color-picker/index.mjs';
import '../../../_common/js/color-picker/cmyk.mjs';
import '../../../_common/js/color-picker/draggable.mjs';
import '../../../_chunks/dep-d8a84e5f.mjs';
import '../../../_chunks/dep-5db111ef.mjs';
import '../../../_chunks/dep-7f2f03b4.mjs';
import '../../../_chunks/dep-b9567f6a.mjs';
import '../../../_chunks/dep-654b4b01.mjs';
import '../../../_chunks/dep-e00db566.mjs';
import '../../../_chunks/dep-fc63c737.mjs';
import '../../../input/input.mjs';
import '../../../_chunks/dep-c3626417.mjs';
import 'tdesign-icons-vue-next';
import '../../../input/props.mjs';
import '../../../form/hooks.mjs';
import '../../../hooks/useConfig.mjs';
import '../../../config-provider/useConfig.mjs';
import '../../../_chunks/dep-adebe2ce.mjs';
import '../../../_chunks/dep-bd3d75f1.mjs';
import '../../../_chunks/dep-2b8d75e2.mjs';
import '../../../_chunks/dep-8f44163a.mjs';
import '../../../_chunks/dep-a255de71.mjs';
import '../../../_chunks/dep-ebe8bc2f.mjs';
import '../../../_chunks/dep-cc371884.mjs';
import '../../../_chunks/dep-1f0070bb.mjs';
import '../../../_chunks/dep-9d0d32fd.mjs';
import '../../../_chunks/dep-ebfafd52.mjs';
import '../../../_chunks/dep-a11a63ea.mjs';
import '../../../_chunks/dep-750294df.mjs';
import '../../../_chunks/dep-ad1accf9.mjs';
import '../../../_chunks/dep-e05e20e6.mjs';
import '../../../_chunks/dep-3e3494dc.mjs';
import '../../../_chunks/dep-42be3824.mjs';
import '../../../_chunks/dep-67dfe9c7.mjs';
import '../../../_chunks/dep-a0bd2e3a.mjs';
import '../../../_chunks/dep-91208ac3.mjs';
import '../../../_chunks/dep-1041f7d7.mjs';
import '../../../_chunks/dep-b32fb318.mjs';
import '../../../_chunks/dep-9b57842b.mjs';
import '../../../_common/js/global-config/default-config.mjs';
import '../../../_common/js/global-config/locale/zh_CN.mjs';
import '../../../_chunks/dep-99a0abba.mjs';
import '../../../_chunks/dep-9d5ee0e1.mjs';
import '../../../config-provider/type.mjs';
import '../../../hooks/useGlobalIcon.mjs';
import '../../../hooks/tnode.mjs';
import '../../../_chunks/dep-f50ac97c.mjs';
import '../../../_chunks/dep-94585de3.mjs';
import '../../../_chunks/dep-d7053a2c.mjs';
import '../../../_chunks/dep-f3e3393e.mjs';
import '../../../_chunks/dep-0fa7026c.mjs';
import '../../../_chunks/dep-31dc9d09.mjs';
import '../../../_chunks/dep-b9d74a58.mjs';
import '../../../utils/render-tnode.mjs';
import '../../../_chunks/dep-ff1c0573.mjs';
import '../../../input/useInput.mjs';
import '../../../form/const.mjs';
import '../../../hooks/index.mjs';
import '../../../hooks/icon.mjs';
import '../../../hooks/slot.mjs';
import '../../../hooks/useCommonClassName.mjs';
import '../../../hooks/useDefaultValue.mjs';
import '../../../hooks/useDestroyOnClose.mjs';
import '../../../hooks/useKeepAnimation.mjs';
import '../../../hooks/useRipple.mjs';
import '../../../utils/set-style.mjs';
import '../../../hooks/useVirtualScroll.mjs';
import '../../../hooks/useVModel.mjs';
import '../../../input/useLengthLimit.mjs';
import '../../../_common/js/log/index.mjs';
import '../../../_common/js/log/log.mjs';
import '../../../_common/js/utils/helper.mjs';
import '../../../_chunks/dep-fdde96c5.mjs';
import '../../../_chunks/dep-961339ce.mjs';
import '../../../input/useInputEventHandler.mjs';
import '../../../input/useInputWidth.mjs';
import '../../../input/input-group.mjs';
import '../../../input/input-group-props.mjs';
import '../../../utils/withInstall.mjs';
import './style/css.mjs';
import '../../../input/type.mjs';
import '../../../input-number/input-number.mjs';
import '../../../button/index.mjs';
import '../../../button/button.mjs';
import '../../../loading/index.mjs';
import '../../../loading/directive.mjs';
import '../../../loading/plugin.mjs';
import '../../../loading/loading.mjs';
import '../../../loading/icon/gradient.mjs';
import '../../../_common/js/loading/circle-adapter.mjs';
import '../../../_common/js/utils/set-style.mjs';
import '../../../utils/dom.mjs';
import '../../../utils/easing.mjs';
import '../../../loading/props.mjs';
import '../../../hooks/useTeleport.mjs';
import '../../../loading/type.mjs';
import '../../../button/props.mjs';
import '../../../button/type.mjs';
import '../../../input-number/props.mjs';
import '../../../input-number/useInputNumber.mjs';
import '../../../_common/js/input-number/number.mjs';
import '../../../_chunks/dep-b7435939.mjs';
import '../../../_common/js/input-number/large-number.mjs';
import '../../../input-number/type.mjs';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var FormatInputs = defineComponent({
  name: "FormatInputs",
  inheritAttrs: false,
  props: _objectSpread(_objectSpread({}, props), {}, {
    color: {
      type: Object
    },
    onInputChange: {
      type: Function,
      "default": function _default() {
        return function () {};
      }
    }
  }),
  setup: function setup(props2) {
    var inputConfigs = computed(function () {
      var configs = _toConsumableArray(FORMAT_INPUT_CONFIG[props2.format]);
      if (props2.enableAlpha) {
        configs.push({
          type: "inputNumber",
          key: "a",
          min: 0,
          max: 100,
          format: function format(value) {
            return "".concat(value, "%");
          },
          flex: 1.15
        });
      }
      return configs;
    });
    var modelValue = reactive({});
    var lastModelValue = reactive({});
    var getFormatColorMap = function getFormatColorMap(type) {
      var color = props2.color;
      if (type === "encode") {
        return {
          HSV: color.getHsva(),
          HSL: color.getHsla(),
          RGB: color.getRgba(),
          CMYK: color.getCmyk(),
          CSS: {
            css: color.css
          },
          HEX: {
            hex: color.hex
          }
        };
      }
      return {
        HSV: Color.object2color(modelValue, "HSV"),
        HSL: Color.object2color(modelValue, "HSL"),
        RGB: Color.object2color(modelValue, "RGB"),
        CMYK: Color.object2color(modelValue, "CMYK"),
        CSS: modelValue.css,
        HEX: modelValue.hex
      };
    };
    var updateModelValue = function updateModelValue() {
      var format = props2.format,
        color = props2.color;
      var values = getFormatColorMap("encode")[format];
      values.a = Math.round(color.alpha * 100);
      Object.keys(values).forEach(function (key) {
        modelValue[key] = values[key];
        lastModelValue[key] = values[key];
      });
    };
    updateModelValue();
    var throttleUpdate = throttle_1(updateModelValue, 100);
    watch(function () {
      var _props2$color = props2.color,
        saturation = _props2$color.saturation,
        hue = _props2$color.hue,
        value = _props2$color.value,
        alpha = _props2$color.alpha;
      return [saturation, hue, value, alpha, props2.format];
    }, throttleUpdate);
    var handleChange = function handleChange(key, v) {
      if (v === lastModelValue[key]) {
        return;
      }
      var value = getFormatColorMap("decode")[props2.format];
      props2.onInputChange(value, modelValue.a / 100, key, v);
    };
    return {
      modelValue: modelValue,
      inputConfigs: inputConfigs,
      handleChange: handleChange
    };
  },
  render: function render() {
    var _this = this;
    var inputProps = _objectSpread({}, this.inputProps || {});
    return createVNode("div", {
      "class": "input-group"
    }, [this.inputConfigs.map(function (config) {
      return createVNode("div", {
        "class": "input-group__item",
        "key": config.key,
        "style": {
          flex: config.flex || 1
        }
      }, [config.type === "input" ? createVNode(Input, mergeProps(inputProps, {
        "align": "center",
        "size": "small",
        "disabled": _this.disabled,
        "modelValue": _this.modelValue[config.key],
        "onUpdate:modelValue": function onUpdateModelValue($event) {
          return _this.modelValue[config.key] = $event;
        },
        "maxlength": _this.format === "HEX" ? 9 : void 0,
        "title": _this.modelValue[config.key],
        "onBlur": function onBlur(v) {
          return _this.handleChange(config.key, v);
        },
        "onEnter": function onEnter(v) {
          return _this.handleChange(config.key, v);
        }
      }), null) : createVNode(InputNumber, mergeProps(inputProps, {
        "align": "center",
        "size": "small",
        "disabled": _this.disabled,
        "modelValue": _this.modelValue[config.key],
        "onUpdate:modelValue": function onUpdateModelValue($event) {
          return _this.modelValue[config.key] = $event;
        },
        "title": _this.modelValue[config.key],
        "min": config.min,
        "max": config.max,
        "step": 1,
        "format": config.format,
        "theme": "normal",
        "onBlur": function onBlur(v) {
          return _this.handleChange(config.key, v);
        },
        "onEnter": function onEnter(v) {
          return _this.handleChange(config.key, v);
        }
      }), null)]);
    })]);
  }
});

export { FormatInputs as default };
//# sourceMappingURL=inputs.mjs.map
